/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { FirmwareUpgradeService } from '../../shared/services/firmware-upgrade.service';
import { SamService } from './sam.service';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ModalService } from '@msi/cobalt';

@Injectable({ providedIn: 'root' })
export class SamFirmwareUpgradeService extends FirmwareUpgradeService {
    public readonly FIRMWARE: { [key: string]: string } = {
        '1.0.63': 'assets/firmware/SAM_FIRMWARE_1.0.63.bin'
    };
    constructor(
        public rtiService: SamService,
        protected http: HttpClient,
        protected store: Store,
        protected modalService: ModalService
    ) {
        super(rtiService, http, store, modalService);
    }
}
